document.addEventListener('turbo:load', function(e) {
  
  /* --------------------------------------------------
                Player
  -------------------------------------------------- */
  const pgGuidesShowPlayer = function() {
    const guideData = window.guideData;
    if (!guideData) return;
    const scriptContainer = document.getElementById('guides-script');
    const screenshotImage = document.getElementById('guides-screenshot-image');
    const audioPlayer = document.getElementById("guides-audio-player");
    const audioPlayPauseBtn = document.getElementById("guides-audio-play-pause-btn");
    const audioPlayIcon = document.getElementById("guides-audio-play-icon");
    const audioPauseIcon = document.getElementById("guides-audio-pause-icon");
    const audioProgressBar = document.getElementById("guides-audio-progress-bar");
    const audioProgressHandle = document.getElementById("guides-audio-progress-handle");
    const audioProgressContainer = document.getElementById("guides-audio-progress-container");
    const audioCurrentTimeEl = document.getElementById("guides-audio-current-time");
    const audioDurationEl = document.getElementById("guides-audio-duration");
    const screenshotPlayPauseBtn = document.getElementById("guides-screenshot-play-pause-btn");
    const screenshotPlayIcon = document.getElementById("guides-screenshot-play-icon");
    const screenshotPauseIcon = document.getElementById("guides-screenshot-pause-icon");
    const screenshotOverlay = document.getElementById("guides-screenshot-overlay");
    const audioMuteUnmuteBtn = document.getElementById("guides-audio-mute-unmute-btn");
    const audioVolumeOnIcon = document.getElementById("guides-audio-volume-on-icon");
    const audioVolumeOffIcon = document.getElementById("guides-audio-volume-off-icon");

    // Check if Elements Exist
    if (!audioPlayer || !scriptContainer || !audioPlayPauseBtn || !screenshotPlayPauseBtn || !audioMuteUnmuteBtn) return;

    // Set Audio Player Source
    audioPlayer.src = guideData.audio_url;

    // Get Step Elements
    const stepElements = scriptContainer.querySelectorAll('.guide-step');

    // Format Time
    const formatTime = (time) => {
      if (isNaN(time)) return "00:00";
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    // Time to Seconds
    const timeToSeconds = (timeStr) => {
      const [minutes, seconds] = timeStr.split(':').map(Number);
      return (minutes * 60) + seconds;
    };

    // Toggle Mute
    const toggleMute = () => {
      audioPlayer.muted = !audioPlayer.muted;
    };

    // Update Mute Button
    const updateMuteButton = () => {
      if (audioPlayer.muted) {
        audioVolumeOnIcon.classList.add("hidden");
        audioVolumeOffIcon.classList.remove("hidden");
      } else {
        audioVolumeOnIcon.classList.remove("hidden");
        audioVolumeOffIcon.classList.add("hidden");
      }
    };

    // Event Handlers
    const togglePlay = () => {
      if (audioPlayer.paused) {
        audioPlayer.play();
      } else {
        audioPlayer.pause();
      }
    };

    // Update Play Button
    const updatePlayButton = () => {
      if (audioPlayer.paused) {
        audioPlayIcon.classList.remove("hidden");
        audioPauseIcon.classList.add("hidden");
        screenshotPlayIcon.classList.remove("hidden");
        screenshotPauseIcon.classList.add("hidden");
      } else {
        screenshotOverlay.classList.add('opacity-0', 'group-hover:opacity-100')
        audioPlayIcon.classList.add("hidden");
        audioPauseIcon.classList.remove("hidden");
        screenshotPlayIcon.classList.add("hidden");
        screenshotPauseIcon.classList.remove("hidden");
      }
    };

    // Update Progress
    const updateProgress = () => {
      const progressPercentage = (audioPlayer.currentTime / audioPlayer.duration) * 100;
      audioProgressBar.style.width = `${progressPercentage}%`;
      audioProgressHandle.style.left = `${progressPercentage}%`;
      audioCurrentTimeEl.textContent = formatTime(audioPlayer.currentTime);
      highlightActiveStep();
    };

    // Set Progress
    const setProgress = (e) => {
      const rect = audioProgressContainer.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const width = rect.width;
      const duration = audioPlayer.duration;
      audioPlayer.currentTime = (offsetX / width) * duration;
    };

    // Highlight Active Step
    const highlightActiveStep = () => {
      const currentTime = audioPlayer.currentTime;
      let activeStep = null;

      for(let i = 0; i < guideData.steps.length; i++) {
        const step = guideData.steps[i];
        const nextStep = guideData.steps[i + 1];
        const startTime = timeToSeconds(step.start_time);
        const endTime = nextStep ? timeToSeconds(nextStep.start_time) : audioPlayer.duration;

        if (currentTime >= startTime && (currentTime < endTime || !audioPlayer.duration)) {
          activeStep = step;
        }
      }
      
      // Highlight Active Step
      stepElements.forEach(stepEl => {
        const stepId = parseInt(stepEl.dataset.id);
        if (activeStep && stepId === activeStep.id) {
          if (!stepEl.classList.contains('active')) {
            stepEl.classList.add('active');
            stepEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            updateScreenshot(activeStep);
          }
        } else {
          stepEl.classList.remove('active');
        }
      });
    };
    
    // Update Screenshot
    const updateScreenshot = (step) => {
      if (step) {
        const screenshotUrl = `https://storage.googleapis.com/biddyhq/guides-${guideData.guide_id}-${step.id}.png?timestamp=${new Date().getTime()}`;
        screenshotImage.src = screenshotUrl;
        screenshotImage.style.display = 'block';

        screenshotImage.onerror = () => {
          screenshotImage.style.display = 'none';
        };
      } else {
        screenshotImage.src = '';
        screenshotImage.style.display = 'none';
      }
    };

    // Event Listeners
    stepElements.forEach(stepEl => {
      stepEl.addEventListener('click', () => {
        audioPlayer.currentTime = timeToSeconds(stepEl.dataset.startTime);
        if (audioPlayer.paused) {
          audioPlayer.play();
        }
      });
    });
    
    // Event Listeners
    audioPlayPauseBtn.addEventListener("click", togglePlay);
    screenshotPlayPauseBtn.addEventListener("click", togglePlay);
    audioMuteUnmuteBtn.addEventListener("click", toggleMute);
    audioPlayer.addEventListener("play", updatePlayButton);
    audioPlayer.addEventListener("pause", updatePlayButton);
    audioPlayer.addEventListener("volumechange", updateMuteButton);
    audioPlayer.addEventListener("timeupdate", updateProgress);
    audioProgressContainer.addEventListener("click", setProgress);

    audioPlayer.addEventListener("loadedmetadata", () => {
      audioDurationEl.textContent = formatTime(audioPlayer.duration);
    });

    // Initial State
    if (guideData.steps.length > 0) {
      updateScreenshot(guideData.steps[0]);
    }
    updateMuteButton();
  }

  /* --------------------------------------------------
                Initialize
  -------------------------------------------------- */
  pgGuidesShowPlayer()
});
